// src/services/reviewService.js
import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  },
});

/* ===============================
   ADMIN REVIEWS
================================ */

/**
 * Admin: Get all reviews
 */
export const fetchAllReviewsAdmin = () => api.get("/admin/reviews");

/**
 * Admin: Delete a review by ID
 * @param {number} reviewId
 */
export const deleteReviewAdmin = (reviewId) =>
  api.delete(`/admin/reviews/${reviewId}`);

/**
 * Admin: Verify or unverify a review
 * @param {number} reviewId
 * @param {boolean} verify
 */
export const verifyReviewAdmin = (reviewId, verify) =>
  api.put(`/admin/reviews/${reviewId}/verify?status=${verify}`);

/**
 * Admin: Update a review
 * @param {number} reviewId
 * @param {{ rating: number, review: string }} data
 */
export const updateReviewAdmin = (reviewId, data) =>
  api.put(`/admin/reviews/${reviewId}`, data);
